/**
 * An equivalent copy of this file exists in billing-ui, ficon-ui and
 * lightning-ui. Unless a change is app-specific, apply it there too.
 */
import type { RouteLocationNormalized } from 'vue-router';

import { useVersionStore } from '@/stores/VersionStore';

export default (to: RouteLocationNormalized): false | void => {
  const { isHardRefreshEnabled, requiresHardRefresh, setRequiresHardRefresh } =
    useVersionStore();

  if (!isHardRefreshEnabled.value || !requiresHardRefresh.value) {
    return;
  }

  setRequiresHardRefresh(false);
  const urlString = `${window.location.origin}${import.meta.env.BASE_URL}${to.fullPath.slice(1)}`;
  window.location.href = urlString;

  // Explicitly returning 'false' - Cancels Vue Router's SPA navigation
  // so no further guards run or components mount while the browser hard reload is in progress.
  return false;
};
